import React, { useState, useEffect } from "react";
import useRequestForgotPassword from "../../Hooks/useRequestForgotPassword";
import otpPage from "../../Assets/forgotPassword/otpPage.svg";
import logo from "../../Assets/logo.png";
import { ButtonWithoutIcon, Loader } from "../../constents/components";
import useVerifyOtp from "../../Hooks/useVerifyOtp";
import ResetPassword from "./ResetPassword";

function OtpPage({ email }) {
    const [loading, error, success, requestFunction] = useRequestForgotPassword();
    const [otpLoading, otpError, otpSuccess, submitOtp] = useVerifyOtp();
    const [passwordPage, setPasswordPage] = useState(false);
    const [otpValues, setOtpValues] = useState("");
    const [resendCodeLoading, setResendCodeLoading] = useState(false);
    const [timer, setTimer] = useState(0);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [timer]);

    const resendCode = async () => {
        if (timer > 0) return;

        setResendCodeLoading(true);
        setTimer(60);

        try {
            if (email) {
                await requestFunction(email);
            }
        } catch (err) {
            // console.log(err);
        } finally {
            setResendCodeLoading(false);
        }
    };

    const submitRequest = async (e) => {
        e.preventDefault();
        try {
            if (otpValues) {
                await submitOtp(email, otpValues);
            }
        } catch (err) {
            // console.log(err);
        }
    };

    useEffect(() => {
        if (otpSuccess) {
            setPasswordPage(true);
        }
    }, [otpSuccess]);

    if (passwordPage) {
        return <ResetPassword email={email} />;
    }

    return (
        <div className="h-screen w-screen flex flex-col md:flex-row">
            <div className="bg-pills-bg-color-900 flex flex-col items-center py-4 px-4 md:w-1/2 md:justify-center">
                <div className="mb-2 md:mb-6">
                    <img
                        src={logo}
                        alt="Zepcruit logo"
                        className="h-8 md:hidden md:h-10"
                    />
                </div>
                <div className="w-full max-w-md my-4 md:my-8">
                    <img
                        src={otpPage}
                        alt="Reset password illustration"
                        className="w-44 max-w-xs mx-auto md:w-96"
                    />
                </div>
                <h2 className="font-semibold text-center mt-4 mb-1 text-lg md:text-3xl">
                    Recruitment is Time-Consuming, but Not with Zepcruit
                </h2>
            </div>

            <div className="flex-1 flex flex-col items-center justify-between px-4 py-6 bg-white-bg-color md:w-1/2 md:py-20">
                <div className="w-full max-w-md md:max-w-lg">
                    <div className="hidden md:block md:text-center md:mb-10">
                        <img src={logo} alt="Zepcruit logo" className="h-10 inline-block" />
                    </div>

                    <h3 className="text-2xl text-center mb-2 md:text-3xl">OTP Code</h3>
                    <p className="hidden md:block text-text-color-strong text-sm text-center mb-6">
                        Access your account and start exploring new opportunities.
                    </p>
                    <p className="md:hidden text-text-color-strong text-xs text-center mb-6 md:mb-8">
                        We have sent code to your email{" "}
                        <span className="font-bold">{email}</span>
                    </p>

                    <form
                        onSubmit={submitRequest}
                        className="flex flex-col justify-between h-full md:h-0"
                    >
                        <div className="mt-4 flex flex-col items-center justify-center md:justify-start">
                            <input
                                type="number"
                                className="border-b-2 p-1 text-center outline-none"
                                placeholder="Enter OTP"
                                onChange={(e) => setOtpValues(e.target.value)}
                            />
                            <div className="mt-4 mx-auto">
                                <p className="text-text-color text-xs">
                                    Didn't receive email?{" "}
                                    {
                                        timer > 0 ?
                                            <span className="text-black">Resend Code in {timer} seconds</span>
                                            :
                                            <button className="text-primary-color-900 font-semibold cursor-pointer" onClick={resendCode}>Resend Code</button>
                                    }
                                </p>
                            </div>
                        </div>

                        <div className="mt-auto pt-16 md:pt-16 w-full">
                            {otpLoading ? (
                                <Loader />
                            ) : (
                                <ButtonWithoutIcon
                                    classNames="w-full text-white-bg-color py-4 px-6 rounded-full font-medium bg-black hover:bg-gray-800"
                                    text="Verify Code"
                                    loading={loading}
                                />
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default OtpPage;